/* eslint-disable no-unused-vars */
import './scss/index.scss';

// Make sure JS is enabled and the window is ready.
import './components/js-enabled';
import './components/programs';
import './components/accordion';
import './components/did-you-know';
import './components/wavy-arrow';
import './components/range-slider';
import './components/image-blobs';
import './components/lava-lamp';
import './components/confetti';
import './components/entry-animations';
import wdsWindowReady from './components/window-ready';

// Components.
import ngenMainNavigation from './components/navigation-primary';
import wdsSkipLinkFocusFix from './components/skip-link-focus-fix';
import wdsVideo from './components/video';
